import {USER_PROFILE_FIELD_PREFIX, ADVISOR_PROFILE_FIELD_PREFIX} from '@/constants/engine';
import {DocumentData} from '@/engine';
import {UserProfile, UserProfileCompletionStatus} from '@/repositories/beneva-api/endpoints/users';

export const hasCompleteUserProfile = (profile?: UserProfile | null): boolean =>
  profile?.completionMetadata.status === UserProfileCompletionStatus.Complete || false;

export const getUserProfileAsDocumentData = (profile?: UserProfile): DocumentData['data'] => {
  if (!profile) return {};

  return Object.entries(profile).reduce<DocumentData['data']>((acc, [key, value]) => {
    if (key.startsWith(ADVISOR_PROFILE_FIELD_PREFIX)) {
      const id = key
        .split('_')
        .at(0)
        ?.replace(ADVISOR_PROFILE_FIELD_PREFIX.toLowerCase(), USER_PROFILE_FIELD_PREFIX)
        .toUpperCase();

      if (!id) return acc;

      acc[id] = value !== null ? (typeof value === 'object' ? value : `${value}`) : '';
    }
    return acc;
  }, {});
};
